import { Alert } from "@material-ui/lab";

import { useSubaccount } from "src/components/SubaccountProvider";
import { getCampaign_campaign } from "src/graphql/generated/getCampaign";

export default function BandwidthVoiceWarning({
  campaign
}: {
  campaign: getCampaign_campaign;
}): JSX.Element {
  const { subaccount } = useSubaccount()!;

  if (campaign.provider === "bandwidth") {
    return (
      <Alert severity="warning" style={{ marginBottom: "20px" }}>
        This campaign is using our backup telephony provider.
        {subaccount.settings.callbackNumber && " Callbacks are not enabled."}
      </Alert>
    );
  }

  return <></>;
}
